import { getEpicStoreAccountId } from './getEpicStoreAccountId.js';
import { queryEpicStoreOffers } from './queryEpicStoreOffers.js';
import { startEpicStoreCheckout } from './startEpicStoreCheckout.js';

var EpicGamesStore = {
    getEpicStoreAccountId,
    queryEpicStoreOffers,
    startEpicStoreCheckout,
};

export { EpicGamesStore as default };
//# sourceMappingURL=index.js.map
